import React from 'react';
import * as Styles from "./carousel.css";
import Carousel from "./carousel";

const CarouselSect = (props) => {

    return (
        <Styles.CarouselSection>
            <div className="container">
                <Styles.CarouselRow>
                    <Carousel />
                </Styles.CarouselRow>
                <Styles.Column>
                    <Styles.CarouselSubHeader>
                        Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy
                    </Styles.CarouselSubHeader>
                    <Styles.CarouselHeader>
                        Lorem ipsum dolor sit amet, consetetur
                    </Styles.CarouselHeader>
                    <Styles.CarouselLightTxt>
                        Lorem ipsum now
                    </Styles.CarouselLightTxt>
                    {/* <div className="columns">
                        <div className="column is-four-fifths">is-four-fifths</div>
                        <div className="column">Auto</div>
                        <div className="column">Auto</div>
                    </div> */}
                    <div className=" column is-two-thirds" style={{margin: 'auto'}}>
                        <Styles.CarouselParagraph>
                            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.
                    </Styles.CarouselParagraph>
                    </div>
                    <div className=" column is-one-third" style={{margin: 'auto', display: 'flex', justifyContent: 'center'}}>
                    <Styles.GetStartedButton>
                        Lorem Ipsium Now
                    </Styles.GetStartedButton>
                    </div>
                </Styles.Column>
            </div>

        </Styles.CarouselSection>
    );
}

export default CarouselSect;